import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import BugReportIcon from '@mui/icons-material/BugReport';
import { useTranslation } from 'react-i18next';
import { useBugReport } from './BugReportProvider';

/**
 * SMSPRO-141 — einheitliche Höhe der TopBar-Bedienelemente.
 * Muss mit TOPBAR_CONTROL_HEIGHT in TopBar.tsx übereinstimmen (kein Import,
 * um einen Zirkelbezug TopBar -> BugReportButton -> TopBar zu vermeiden).
 */
const CONTROL_HEIGHT = 32;

/**
 * Melde-Knopf der Kopfzeile. Bildschirmabzug, Melde-Dialog und Rückmeldungen
 * liegen im `BugReportProvider` und existieren dort genau einmal; dieser Knopf
 * und die Knöpfe in den Popup-Titelzeilen (`AppDialogTitle`) lösen nur aus.
 * Ohne Anbieter wird nichts angezeigt.
 */
export function BugReportButton() {
  const { t } = useTranslation();
  const bug = useBugReport();
  if (!bug) return null;
  const capturing = bug.aufnahmeLaeuft;

  return (
      <Tooltip title={capturing ? t('bugReport.capturing', 'Bildschirmabzug wird erstellt…') : t('bugReport.fab')}>
        <span>
          <IconButton
            size="small"
            onClick={bug.starteMeldung}
            disabled={capturing}
            aria-busy={capturing}
            data-bug-report-button=""
            aria-label="bug-report"
            // Quadratisch (Höhe == Breite), damit die runde Klickfläche mittig
            // bleibt; 30px (size="small" + 5px padding) waren vorher zu niedrig.
            sx={{ width: CONTROL_HEIGHT, height: CONTROL_HEIGHT, p: 0, flexShrink: 0 }}
          >
            <BugReportIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
  );
}
